





import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import { ATH, AST, ACT, getTastChainType } from '@/known_blockchains'
import { DEFAULT_NETWORK } from '@/store/modules/network/network'

@Component({})
export default class TxHeader extends Vue {
    get astChain() {
        return getTastChainType(AST.id)
    }

    get athChain() {
        return getTastChainType(ATH.id)
    }

    get actChain() {
        return getTastChainType(ACT.id)
    }

    get actChainURL() {
        // return DEFAULT_NETWORK_ID === 1
        //     ? actChainExplorerURL
        //     : actChainExplorerURL_test
        return DEFAULT_NETWORK.actChainExplorerURL
    }
}
